/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconNumber9Small = createReactComponent("outline", "number-9-small", "IconNumber9Small", [["path", { "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-0" }]]);

export { IconNumber9Small as default };
//# sourceMappingURL=IconNumber9Small.mjs.map
